import { render, staticRenderFns } from "./Articlelist.vue?vue&type=template&id=cc8b27b8&scoped=true"
import script from "./Articlelist.vue?vue&type=script&lang=js"
export * from "./Articlelist.vue?vue&type=script&lang=js"
import style0 from "./Articlelist.vue?vue&type=style&index=0&id=cc8b27b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8b27b8",
  null
  
)

export default component.exports